export const navigation = [
  {
    name: 'menu.dashboard',
    url: '/dashboard',
    icon: 'icon-graph' /*,
    badge: {
      variant: 'info',
      text: 'NEW'
    }*/
  },
  {
    name: 'menu.visibility',
    url: '/tables/',
    icon: 'fa fa-search',
    children: [
      {
        name: 'menu.total',
        url: '/total-graph',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.hr',
        url: '/hr',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.personalSpent',
        url: '/personal-spent',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'Top 20',
        url: '',
        icon: 'fa fa-search',
        children: [
          {
            name: 'menu.topRoaming',
            url: '/top-roaming',
            icon: 'fa fa-arrow-right'
          },
          {
            name: 'menu.topData',
            url: '/top-data',
            icon: 'fa fa-arrow-right'
          }
        ]
      },
      /*{
        name: 'menu.wizard',
        url: '/wizard',
        icon: 'fa fa-arrow-right'
      },*/
      {
        name: 'menu.linesInt',
        url: '/plans-linesInt',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.widgets',
        url: '/statistics',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.planStatistics',
        url: '/plan-stat',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.locations',
        url: '/locations',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.search',
        url: '/search',
        icon: 'fa fa-arrow-right'
      }
    ]
  },
  {
    name: 'menu.optimization',
    url: '/tables/',
    icon: 'fa fa-signal',
    children: [
      {
        name: 'menu.optgraph',
        url: '/optimization-graph',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.detailsTA',
        url: '/detailsTA',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.best',
        url: '/best',
        icon: 'fa fa-arrow-right'
      }
    ]
  },
  {
    name: 'menu.control',
    url: '/tables/',
    icon: 'fa fa-mobile',
    children: [
      /*{
        name: 'menu.renewal',
        url: '/renewal',
        icon: 'fa fa-arrow-right'
      },
      {
        name: 'menu.contract',
        url: '/contract',
        icon: 'fa fa-arrow-right'
      },*/
      {
        name: 'menu.over-lines',
        url: '/overview-lines',
        icon: 'fa fa-arrow-right'
      }
    ]
  },
  {
    name: 'Menu Admin',
    url: '/menuAdmin',
    icon: 'icon-graph' /*,
    badge: {
      variant: 'info',
      text: 'NEW'
    }*/
  }
];



// WEBPACK FOOTER //
// ./src/app/_nav.ts